import React from "react";
import previewChangelog from "./changelog/assets/preview.png";
import previewVersionTag from "./versioning/assets/preview.png";
import "./Features.css";
import Preview from "../../common/preview/Preview";
import Logo from "../../common/logo/Logo";

function Features() {
  return (
    <header className="app-header">
      <div className="app-container features-container">
        <div className="logo-box" style={{ marginBottom: "3rem" }}>
          <Logo navigateTo={"/GitVersioniser"} />
        </div>
        <Preview
          image={previewChangelog}
          text="changelog"
          navlink="/GitVersioniser/changelog"
        />
        <Preview
          image={previewVersionTag}
          text="versioning"
          navlink="/GitVersioniser/versioning"
        />
      </div>
    </header>
  );
}

export default Features;
